export const getEnv = () => {
  const apiUrl = process.env.REACT_APP_MK2_URL?.trimEnd();

  if (!apiUrl) {
    throw new Error('Failed to determine the API URL. Please check your environment variables.');
  }

  if (apiUrl.endsWith('dev')) return 'dev';
  if (apiUrl.endsWith('test')) return 'test';

  return 'prod';
};

const envToSuffixMap = { dev: '-dev', test: '-qa', prod: '' };

export const getEnvSuffix = () => envToSuffixMap[getEnv()];

const envToExternalSuffixMap = {
  dev: '-dev',
  test: '-qa',
  prod: '',
};

export const getExternalEnvSuffix = () => envToExternalSuffixMap[getEnv()];
